export default __webpack_public_path__ + "static/media/pink-film.48347643.png";